import React from 'react'
import { useIntl } from 'react-intl'

import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import useEndingSoonOfferList from 'hooks/EndingSoonOffer/useEndingSoonOfferList'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'

const MIN_OFFERS_WITH_COUNTDOWN = 4

const CarouselContainer = styled(Pane)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function OfferEndingSoonCarousel() {
  const intl = useIntl()
  const endingSoonOfferList = useEndingSoonOfferList()

  const title = intl.formatMessage(
    {
      id: 'Yw4KFRYfjiFEmE4VsWwK',
      defaultMessage: 'Offers <i>ending</i> soon',
      description: 'Title for offers ending soon carousel with italicized "ending"',
    },
    {
      i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
    },
  )

  // TODO: Move visibility decision to SSR to avoid CLS (Cumulative Layout Shift)
  // Currently CSR-only due to stream API limitation. Once unified search API supports
  // ending soon sorting, we can prefetch data server-side and conditionally render.

  const hasEnoughOffers = endingSoonOfferList.offerIds.length >= MIN_OFFERS_WITH_COUNTDOWN

  // Don't render while loading or if there aren't enough offers
  if (endingSoonOfferList.fetching || !hasEnoughOffers) {
    return null
  }

  return (
    <CarouselContainer>
      <VerticalSpacer gap={24}>
        <LayoutContainer>
          <Heading variant="heading2">{title}</Heading>
        </LayoutContainer>
        <OfferListCarousel
          overrideOfferList={endingSoonOfferList}
          tabletLimit="default"
          tileStyle="card-default"
          tileSize="medium"
        />
      </VerticalSpacer>
    </CarouselContainer>
  )
}

export default OfferEndingSoonCarousel
